<template>
  <v-row class="my-0">
    <v-col style="max-width: 60px">
      <StatusAvatar :user="data.item" avatar-size="36px" badge-size="12px" style="width: 40px"/>
    </v-col>
    <v-col>
      <v-list-item-title v-html="data.item.name"></v-list-item-title>
      <v-list-item-subtitle v-html="$t('videoconf.extension', { extension: data.item.exten })"></v-list-item-subtitle>
    </v-col>
  </v-row>
</template>

<script>
import StatusAvatar from '@/components/buddies/status_avatar'
export default {
  components: { StatusAvatar },
  props: {
    data: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  methods: {
    checkType (data) {
      return typeof data.item !== 'object'
    }
  }
}
</script>

<style>

</style>
